import BaseApi from './base';

class Dashboard extends BaseApi {
    endpoint = 'dashboard';
}

export default new Dashboard();




// WEBPACK FOOTER //
// ./src/psuite-js/apis/delivery/dashboard.js